import { getPrePackSize } from "@faire/retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { logAssert } from "@faire/web--source/common/logging";
import { formatMoney, moneyOrZero } from "@faire/web--source/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
export var originalPriceMoney = function(selectedOption) {
    if (!selectedOption) {
        return "--";
    }
    if (isPrePackProductOption(selectedOption)) {
        var _selectedOption_wholesale_price, _selectedOption_wholesale_price1;
        var prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);
        logAssert(prePackUnitCount !== 0 || !isNaN(prePackUnitCount), "Prepack unit count is invalid", {
            data: {
                selectedOption: selectedOption
            }
        });
        var _selectedOption_wholesale_price_amount_cents;
        var price = IFaireMoney.build({
            amount_cents: ((_selectedOption_wholesale_price_amount_cents = (_selectedOption_wholesale_price = selectedOption.wholesale_price) === null || _selectedOption_wholesale_price === void 0 ? void 0 : _selectedOption_wholesale_price.amount_cents) !== null && _selectedOption_wholesale_price_amount_cents !== void 0 ? _selectedOption_wholesale_price_amount_cents : 0) / prePackUnitCount,
            currency: (_selectedOption_wholesale_price1 = selectedOption.wholesale_price) === null || _selectedOption_wholesale_price1 === void 0 ? void 0 : _selectedOption_wholesale_price1.currency
        });
        return formatMoney({
            money: price
        });
    }
    return formatMoney({
        money: moneyOrZero(selectedOption.wholesale_price)
    });
};
